import { INav, INavProps as FINavProps, INavStyles, Nav as FNav } from '@fluentui/react';
import { forwardRef } from 'react';

import { IComponent } from '../../models/components.models';
import { useThemeStyles } from '../../utils/hooks';
import { navStylesDefault } from './Nav.styles';

export interface INavProps extends Omit<FINavProps, 'styles'>, IComponent<INavStyles> {}

export const Nav = forwardRef<INav, INavProps>((props, ref) => {
  const { styles, ..._fProps } = props;
  const fProps: FINavProps = {
    ..._fProps,
    styles: useThemeStyles<Partial<INavStyles>>(navStylesDefault, styles),
  };
  return <FNav {...fProps} componentRef={ref as any} data-test={props['data-test'] || 'nav'} />;
});
